import { LinearProgress, LinearProgressProps } from '@mui/material';
import { Box } from '@mui/system';

import { style } from './style';

type ProgressBarProps = {
  value: number,
  color: string,
  variant? : LinearProgressProps['variant'],
}

export const ProgressBar = ({
  value,
  color,
  variant,
}: ProgressBarProps):JSX.Element => {
  return (
    <Box sx={ style.boxContainer.sx  }>
      <LinearProgress
        variant={ variant }
        sx={ { ...style.progressbar.sx, ...style.linearProgressColor.sx(color) } }
        value={ value }
      />
    </Box>
  );
};

ProgressBar.defaultProps = {
  variant: 'determinate',
};
